<template>
  <ion-page>
    <!-- <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start" @click="goPrev()">
            <ion-icon :icon="arrowBackOutline" />
          </ion-buttons>
          <ion-title>Search</ion-title>
        </ion-toolbar>
      </ion-header> -->
      <ion-searchbar v-model="searchTeamText" ref="searchRef" mode="ios" class="search-bar" animated="true" placeholder="Search for a team" @ionInput="searchTeam($event)" autofocus />
    <ion-content class="menu-content">
      <ion-list :inset="true">
        <ion-item v-for="group in sortedGroups" :key="group._id" @click="selectGroup(group)" class="c-white list-item">
          <ion-icon :icon="getSportIcon(group.type)" slot="start" class="c-white" size="large"></ion-icon>
          <ion-label>
            <h2>{{ group.name || 'Unnamed Group' }} </h2>
            <p>{{ group.type || 'Unknown' }}</p>
          </ion-label>
          <div class="d-grid justify-end text-right">
            <small v-if="group.dateTime">{{ formatDateTime(group.dateTime) }}</small>
            <small v-if="group.venue">{{ group.venue.name }}</small>
            <small>{{ getSportInfo(group) }}</small>
          </div>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-page>
</template>
  
<script>
import { defineComponent } from 'vue';
import { IonContent, IonList, IonItem, IonLabel, IonIcon, IonNote, IonBadge } from '@ionic/vue';
import { golfOutline, bicycleOutline, tennisballOutline, peopleOutline, ribbonOutline } from 'ionicons/icons';
import moment from 'moment';
  
export default defineComponent({
  name: 'LivescoreGroupList',
  components: {
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonIcon,
    IonNote,
    IonBadge
  },
  data() {
    return {
      groups: [],
      searchTeamText: ''
    };
  },
  mounted() {
    this.fetchGroups();
  },
  computed: {
    sortedGroups() {
      let sorted = Object.assign([], this.groups).sort((a, b) => (a.order || 0) - (b.order || 0));
      if (this.searchTeamText) {
        sorted = sorted.filter(group => group.name.toLowerCase().includes(this.searchTeamText.toLowerCase()));
      }
      return sorted;
    }
  },
  methods: {
    searchTeam(event) {
      // console.log(event.target.value);
    },
    getSportIcon(type) {
      switch (type) {
      case 'Golf':
        return golfOutline;
      case 'Race':
        return bicycleOutline;
      case 'Tennis':
        return tennisballOutline;
      case 'Team H2H':
        return peopleOutline;
      case 'Field Event':
      case 'Gymnastics':
        return ribbonOutline;
      default:
        return '';
      }
    },
    async fetchGroups() {
      try {
        const response = await this.$http.get('/assemble/api/v1/livescores/result-groups');
        this.groups = response.data.data
      } catch (error) {
        console.error('Error fetching groups:', error);
      }
    },
    formatDateTime(timestamp) {
      return moment(parseInt(timestamp)).format('YYYY-MM-DD');
    },
    getSportInfo(group) {
      switch (group.type) {
      case 'Golf':
        return `${group.rounds} rounds`;
      case 'Race':
        return `${group.participants.length} participants`;
      case 'Team H2H':
        return `${group.matches.length} matches`;
      case 'Tennis':
        return `${group.singlesDoubles}, ${group.numberOfSets} sets`;
      case 'Field Event':
        return `${group.participants.length} participants`;
      case 'Gymnastics':
        return `${group.participants.length} participants`;
      default:
        return '';
      }
    },
    selectGroup(group) {
      this.$router.push(`/results/${group._id}`);
    }
  }
});
</script>

<style lang="scss" scoped>


ion-title {
  font-family: 'BrownStd-Bold';
}

ion-grid {
  white-space: nowrap;
   --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

.list-item {
  padding: 1rem;
  border-radius: 16px;
  font-family: 'BrownStd-Regular';
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
  // background: transparent;
  background: #171717 !important;
  &:hover {
    background: hsl(225, 6%, 14%) !important;
  }

  margin-bottom: 1rem;

  ion-icon {
    color: white;
  }
}

.header-bar {
  padding: 0.5rem;
}

.search-bar {
  color: #fff;
}

.round-text {
  color: #fff;
  font-family: 'Cairo';
  text-align: center;
  font-size: 14px;
  text-transform: uppercase;
  // text-decoration: underline;
  // text-decoration-color: $highlight;
}

.team-list {
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  padding: 0 1.5rem;
  gap: 1.5rem;
  .team-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

ion-label {
  color: white;
  font-family: 'Cairo';
  font-size: 0.8rem;
}


ion-item {
  --padding-start: 15px;
  --padding-end: 15px;
}
.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.light-text {
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
}
.normal-text {
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
}
.bold-text {
  font-size: 16px;
  font-weight: bold;
}
.score-text {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  /* color: rgba(8, 48, 109, 0.5); */
  color: white;
}

.header {
  --background: #1a2933 !important;
  color: white;
}

.custom-segment {
  background: $background !important;
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .segment-button-checked {
  color: $primary;
  --indicator-box-shadow: none;
  border-bottom: 2px solid $primary;
}

.bye-card {
  margin-inline: 1.5rem;
  position: relative;
  border-radius: 24px;
  cursor: pointer;
  box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  
  font-family: 'BrownStd-Regular';
  color: white;
  background: transparent;
  .round-text {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
}
.custom-card {
  border-radius: 24px;
  cursor: pointer;
  // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  font-family: 'BrownStd-Regular';
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
   box-shadow: none;
  background: #171717 !important;
  margin-inline: 1.5rem;
}
.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: 'BrownStd-Regular';
  text-align: center;
  font-size: .9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios, .list-md {
  padding: 0;
  background: 0;
}

ion-item {
  --background: #232528;
  --color: white;
}

.custom-segment ion-label {
  margin-bottom: 0;
}

ion-content {
  background: $background;
  --background: $background;
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
}

ion-content::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: rgba(0,0,0,0.3);
}

ion-content::-webkit-scrollbar
{
  width: .35rem;
  background-color: rgba(0,0,0,0.3);
}

@media only screen and (max-width: 768px) {
  ion-content::-webkit-scrollbar {
    width: .15rem;
    background-color: rgba(0,0,0,0.3);
  }
}

ion-content::-webkit-scrollbar-thumb
{
  background-color: #888;
}


.overlay {
  background: $background;
  // background: $primary;
  padding: 0rem;
}

ion-toolbar, ion-item {
  --border-width: 0 !important;
  --background: $background;
  --color: white;
}

ion-segment-button {
  --background-hover: white !important;
  --color-hover: $highlight !important;
  --color-checked: $highlight !important;
}

.custom-segment {
  border: none;
  /* background: white; */
  border-radius: 0px;
  border-bottom: 1px solid rgba(177, 177, 177, 0.3);
  padding-top: 1rem;
  border: none;
  background: none;
   display: flex;
  // justify-content: center;
  /* border-radius: 1rem !important; */
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .in-segment {
  color: rgba(177, 177, 177, 1);
  font-size: 1.3rem;
  // background-color: rgba($primary, .7);
}

.custom-segment .segment-button-checked {
  color: rgb(234 68 68);
  border-radius: 0;
  margin-bottom: 0;
  // background-color: rgba($primary, .7);
  color: $highlight;
  font-size: 1.3rem;
  font-weight: 500;
  --indicator-height: 0;
  --indicator-box-shadow: none;
  /* --indicator-color: rgb(234, 68, 68, 0.7);
  --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
  border-bottom: 3px solid $highlight;
}
.custom-segment-ladder {
  // border: none;
  margin: 0 auto;
  margin-top: 1rem;
  display: flex;
  width:70%;
  justify-content: center;
  border-radius: 0.6rem !important;
}

.custom-segment-ladder-button{
  flex-basis: 50%;
}


.custom-segment-ladder ::before {
  border-left: none;
}

.custom-segment-ladder .in-segment {
  color: rgba(177, 177, 177, 1);
  background-color: rgba($primary, .2);
}

.custom-segment-ladder .segment-button-checked {
  color: rgb(234 68 68);
  // margin-bottom: 0;
  background-color: rgba($primary, .7);
  color: $highlight;
  font-weight: 400;
  // --indicator-height: 0;
  // --indicator-box-shadow: none;
  //  --indicator-color: rgb(234, 68, 68, 0.7);
  // --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); 
  // border-bottom: 3px solid $highlight;
}

.empty-container {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-container ion-card {
  padding: 4rem;
  border-radius: 1rem;
  background: transparent;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-placeholder {
  align-items: flex-start;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  color: white;
}

.team-name {
  font-size: 0.8rem;
  white-space: break-spaces;
}

ion-select::part(icon) {
  margin-left: 0.5rem;
  color: white !important;
  opacity: 0.85;
}

.competition-list {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 2rem;
}

.accordion-list {
  width: 80rem;
  // width: 100%;
  margin: 0 1.5rem;
}

.accordion {
  margin-bottom: 10px;
  min-width: 12rem;
  border-radius: 10px;
  overflow: hidden;
  background-color: #17181B ;
  color: white;
}

.accordion-header {
  cursor: pointer;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  background-color: #222;
}

.accordion-content {
  padding: 15px;
}

.team-list-competition {
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  padding: 0 1.5rem;
  gap: 1.5rem;
  .team-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.rotate-arrow {
  transform: rotate(180deg);
  transition: transform 0.2s ease-in-out;
}

.slide-enter-active, .slide-leave-active {
  transition: all 0.2s ease;
}

.slide-enter, .slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>